export const getIsMapLayerOpen = (store) => {
	return store.Map.isMapLayerOpen;
};
